if (!customElements.get('product-parts-dot')) {
  customElements.define('product-parts-dot', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.addEventListener('click', (event) => {
        const button = event.target.closest('[data-part-index]');
        if (!button) return;
        const index = button.dataset.partIndex;
        this.querySelectorAll('[data-part-index]').forEach((item) => {
          const active = item.dataset.partIndex === index;
          item.classList.toggle('active', active);
          item.setAttribute('aria-pressed', String(active));
        });
        this.querySelectorAll('[data-part-panel]').forEach((panel) => {
          panel.hidden = panel.dataset.partPanel !== index;
        });
        if (button.closest('[data-part-panel]')?.hidden) {
          this.querySelector(`[data-part-panel="${index}"] [data-part-index="${index}"]`)?.focus({ preventScroll: true });
        }
      }, { signal: this.controller.signal });
    }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; }
  });
}
